import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { P as Popover } from '../Popover/Popover-C9WXjtKL.js';
import { M as MenuList } from './MenuList/MenuList-ClDFMn5d.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { i as isEventFromWithinElement } from '../LocalModules/storm-ui-utils/dist/esm/isEventFromWithinElement-BvBeBwSW-BvBeBwSW.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-CVa_vjg3-CVa_vjg3.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { O as OnRootContainerMousedown } from '../LocalModules/storm-ui-utils/dist/esm/OnRootContainerMousedown-Bh14xj3_-BLKWZj31.js';

const TriggerWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40027066__sc-22gk9o-0"
})(["display:inline-block;width:", ";"], ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto');
const RootMenuList = /*#__PURE__*/styled(MenuList).withConfig({
  componentId: "sc-storm-ui-40027066__sc-22gk9o-1"
})(["margin-block:", ";margin-inline:", ";", " list-style:none;padding:0;"], ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["margin-inline:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile)));
const Menu = ({
  id,
  align = 'start',
  children,
  disabled = false,
  onClose = noop,
  onClick,
  isOpen,
  position = 'bottom',
  trigger,
  fullWidth,
  taktId,
  taktValue,
  ...rest
}) => {
  const popoverRef = useRef(null);
  const triggerRef = useRef(null);
  const onClickOutside = useCallback(event => {
    if (popoverRef.current && !isEventFromWithinElement(event, popoverRef.current) && !isEventFromWithinElement(event, triggerRef.current)) {
      onClose === null || onClose === void 0 || onClose(event);
    }
  }, [onClose]);
  const onClickTrigger = useCallback(event => {
    if (!disabled) {
      event.stopPropagation();
      event.preventDefault();
      onClick === null || onClick === void 0 || onClick(event);
    }
  }, [disabled, onClick]);
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    switch (key) {
      case KEYBOARD_KEYNAMES.ESCAPE:
      case KEYBOARD_KEYNAMES.TAB:
      case KEYBOARD_KEYNAMES.ENTER:
      case KEYBOARD_KEYNAMES.SPACE:
        onClose === null || onClose === void 0 || onClose(event);
        event.preventDefault();
        break;
    }
  }, [onClose]);
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('menu')
  }, /*#__PURE__*/React__default.createElement(Popover, _extends({
    align: align,
    autoFocus: true,
    position: position,
    isOpen: isOpen,
    popoverRef: popoverRef,
    padding: "none",
    spacing: 10
  }, rest, {
    onClick: onClickTrigger,
    onKeyDown: onKeyDown,
    trigger: /*#__PURE__*/React__default.createElement(TriggerWrapper, {
      ref: triggerRef,
      $fullWidth: fullWidth
    }, /*#__PURE__*/React__default.cloneElement(trigger, {
      'aria-haspopup': 'menu',
      'aria-controls': `${id}`,
      id: `${id}-trigger`,
      disabled
    })),
    fullWidthTrigger: fullWidth
  }), /*#__PURE__*/React__default.createElement(OnRootContainerMousedown, {
    rootContainer: typeof document !== 'undefined' ? document.documentElement : undefined,
    handler: onClickOutside
  }, /*#__PURE__*/React__default.createElement(RootMenuList, {
    id: `${id}`,
    "aria-labelledby": `${id}-trigger`
  }, children))));
};

export { Menu as M };
//# sourceMappingURL=Menu-BIhh0c8t.js.map
